// src/App.js
import React, { useContext } from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Footer from './components/Footer';
import styled, { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider, ThemeContext } from './context/ThemeContext';
import ThemeToggle from './components/ThemeToggle';

const AppLayout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.footerBackground};
  color: ${({ theme }) => theme.footerText};
`;

const ThemedApp = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <StyledThemeProvider theme={theme}>
      <AppLayout>
        <Navbar>
          <ThemeToggle />
        </Navbar>
        <main style={{ flex: 1 }}>
          <Home />
        </main>
        <Footer />
      </AppLayout>
    </StyledThemeProvider>
  );
};

export default function App() {
  return (
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  );
}
